// Emisión local/offline de un certificado autofirmado a partir de una CSR,
// usando la misma CA de prueba y los mismos defaults que AdvancedSettings.vue
// (jsrsasign, cargado como global via <script> en index.html).

const CA_KEY_PEM = `-----BEGIN RSA PRIVATE KEY-----
Proc-Type: 4,ENCRYPTED
DEK-Info: DES-EDE3-CBC,4626F2E5853E783F

3vFpkrnbantC8RSzng2+jBw/VX95oi0VGKP0G8whENHUOVQXB/YOUSj+n80Y0Wwc
GpeQi8U0FQdWyYv8b9aioeFB06r9t9mJsYscJ/wcIvv5tTMkr89cwN3+4GQQuqNg
TmI9ekeoZ3NP26hTM4XTuFqHx4dzNNwjDLc8txc77WE/o4J4p8k9Py5yPZjs9EKy
wy/yxtqQYQuFj90OMEG1G89iHTZRcq4YTZYdqg6P/XEUvyjifN+7Nym8f2N9TDDn
RJtApPQlrgXvUDQKz6Lu1ZYMwe94E9YdutDGQMbxixbiyxlcxrkb/oEHH5WP5qPG
w/xzh08Ce2Ftba2Q860S8nznjyZFiv+lqSKBahbujgP/63ZL+JbAd4cYBqgm4g1C
YwMhHJbaVCzwYduxdyK2JBYEosDZiDfnOP4DqPhJYpg=
-----END RSA PRIVATE KEY-----`;
const CA_KEY_PASS = 'hoge';
const ISSUER_DN = '/C=US/O=JS-TEST-CA';
const SUBJECT_DN = '/C=US/CN=Test User1';
const NOT_BEFORE = '200501235959Z';
const NOT_AFTER = '230501235959Z';
const CDP_URI = 'http://test.com/jsca.crl';

function assertJsrsasignLoaded() {
    if (typeof KEYUTIL === 'undefined' || typeof KJUR === 'undefined') {
        throw new Error('jsrsasign no está cargado (falta el script global thirdparty/jsrsasign-latest-all-min.js)');
    }
}

// Misma lógica y mismos defaults que AdvancedSettings.vue -> doIssue(), sin
// depender del formulario DOM: BasicConstraints (critical, cA:false),
// KeyUsage (no critical, solo digitalSignature) y CRLDistributionPoints
// (no critical, URL de prueba). Devuelve solo el cuerpo base64 del
// certificado (jsrsasign no agrega el header/footer -----BEGIN CERTIFICATE-----).
export function issueCertificateFromCsr(csrPem) {
    assertJsrsasignLoaded();

    const publicKey = KEYUTIL.getKeyFromCSRPEM(csrPem);

    const tbsc = new KJUR.asn1.x509.TBSCertificate();
    tbsc.setSerialNumberByParam({ int: Math.floor(Math.random() * 10000000000000000) });
    tbsc.setSignatureAlgByParam({ name: 'SHA256withRSA' });
    tbsc.setIssuerByParam({ str: ISSUER_DN });
    tbsc.setNotBeforeByParam({ str: NOT_BEFORE });
    tbsc.setNotAfterByParam({ str: NOT_AFTER });
    tbsc.setSubjectByParam({ str: SUBJECT_DN });
    tbsc.setSubjectPublicKeyByParam({ rsapem: KEYUTIL.getPEM(publicKey) });

    tbsc.appendExtension(new KJUR.asn1.x509.BasicConstraints({ critical: true, cA: false }));
    tbsc.appendExtension(new KJUR.asn1.x509.KeyUsage({ critical: false, bin: '100000000' }));
    tbsc.appendExtension(new KJUR.asn1.x509.CRLDistributionPoints({ critical: false, uri: CDP_URI }));

    const caKey = KEYUTIL.getKey(CA_KEY_PEM, CA_KEY_PASS);
    const cert = new KJUR.asn1.x509.Certificate({ tbscertobj: tbsc, prvkeyobj: caKey });
    cert.sign();
    return cert.getPEMString();
}

export function wrapCsrAsPem(rawCsr) {
    return `-----BEGIN CERTIFICATE REQUEST-----\n${rawCsr}\n-----END CERTIFICATE REQUEST-----`;
}

export function wrapAsPkcs7(certBody) {
    return `-----BEGIN PKCS7-----\n${certBody}\n-----END PKCS7-----`;
}
